<template>
  <div v-if="$store.getters.schoolConfig.canTranslate">
    <v-btn icon class="translateIcon" @click="requestTranslation">
      <svg viewBox="0 0 24 24">
        <path v-if="!translated" d="M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
        <path v-else d="M9.4 4.44C9.19 4.83 9 5.23 8.84 5.64L10.37 7.17C10.78 6.05 11.33 5 12 4.03C12.83 5.23 13.5 6.57 13.91 8H11.2L13.2 10H14.34C14.4 10.41 14.44 10.84 14.47 11.27L16.44 13.24C16.47 12.83 16.5 12.42 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12S19.9 13.36 19.74 14H17.2L20.5 17.28C21.44 15.75 22 13.94 22 12C22 6.5 17.5 2 12 2C10.06 2 8.25 2.56 6.72 3.5L8.18 5C8.57 4.77 9 4.58 9.4 4.44M18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.34 18.92 8M2.39 1.73L1.11 3L4.06 5.95C2.77 7.63 2 9.73 2 12C2 17.5 6.5 22 12 22C14.28 22 16.37 21.23 18.06 19.95L20.84 22.73L22.11 21.46L2.39 1.73M5.5 7.37L6.11 8H5.08C5.2 7.78 5.34 7.58 5.5 7.37M4.26 14C4.1 13.36 4 12.69 4 12S4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12S7.56 13.34 7.64 14H4.26M5.08 16H8C8.35 17.25 8.8 18.45 9.4 19.56C7.57 18.93 6.03 17.65 5.08 16M9.5 12C9.5 11.8 9.5 11.61 9.53 11.42L12.11 14H9.66C9.56 13.34 9.5 12.68 9.5 12M12 19.96C11.17 18.76 10.5 17.43 10.09 16H13.91C13.5 17.43 12.83 18.76 12 19.96M14.59 19.56C14.96 18.88 15.26 18.15 15.5 17.41L16.62 18.5C16 18.95 15.32 19.31 14.59 19.56Z" />
      </svg>
    </v-btn>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          {{ $vuetify.t('$vuetify.Translation.translationLanguage') }}
        </v-card-title>
        <v-card-text>
          <v-select
            :items="languageNames"
            :label="$vuetify.t('$vuetify.Translation.selectLanguage')"
            v-model="selectedLanguage"
            item-text="text"
            item-value="value"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="selectLanguage">{{ $vuetify.t('$vuetify.Translation.apply') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data: function () {
    return {
      translated: false,
      dialog: false,
      deeplKey: this.$store.getters.translateServer,
      selectedLanguage: this.$store.getters.translationLanguage,
      languages: this.$store.getters.supportedLanguages
    }
  },
  computed: {
    languageNames () {
      let languageList = []
      this.languages.forEach(element => {
        languageList.push({value: element.value, text: this.$vuetify.t('$vuetify.Translation.' + element.text)})
      })
      return languageList
    }
  },
  methods: {
    requestTranslation: function () {
      if (this.selectedLanguage === 'default') {
        this.dialog = true
      } else {
        this.translate()
      }
    },
    selectLanguage: function () {
      if (this.selectedLanguage !== 'default') {
        this.$store.commit('SET_TRANSLATION_LANGUAGE', this.selectedLanguage)
        this.translate()
      }
      this.dialog = false
    },
    translate: function () {
      const domElements = document.getElementsByClassName('translate')
      this.translated = !this.translated

      Array.prototype.forEach.call(domElements, (element) => {
        if (!element.hasOwnProperty('translations')) element.translations = {}
        if (!element.translations.hasOwnProperty('default')) element.translations['default'] = element.innerHTML

        const lang = !this.translated ? 'default' : this.selectedLanguage

        if (lang !== 'default') {
          if (!element.translations.hasOwnProperty(lang)) {
            const params = new URLSearchParams()
            params.append('text', element.innerHTML)
            params.append('target_lang', lang)
            return axios.post('https://api-free.deepl.com/v2/translate?auth_key=' + this.deeplKey, params)
              .then((response) => {
                element.translations[lang] = response.data.translations[0].text
                element.innerHTML = element.translations[lang]
              })
          } else {
            element.innerHTML = element.translations[lang]
          }
        } else {
          element.innerHTML = element.translations['default']
        }
      })
    }
  },
  mounted () {
    // console.log(this.deeplKey)
  }
}
</script>

<style lang="scss" scoped>
  .translateIcon svg {
    width:24px;
    height:24px;
    opacity: 0.7;
  }
</style>
